import _cloneDeep from 'lodash/cloneDeep';

export default class RecentEventsController {
    $onChanges(changes) {
        if (changes.events) {
            this.events = _cloneDeep(changes.events.currentValue);
        }
    }
}



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-details/recent-events/recent-events.controller.js